import React, { useState } from 'react';

import createSnapShot from 'services/snapshot/createSnapshot';
import SidebarCameraIcon from 'components/layout/buttons/SidebarCameraIcon';
import SnapshotModal from 'components/configurator/modals/SnapshotModal';

import 'style/layout/Buttons.css';
import ISnapShotOptions from '../../interfaces/ISnapShotOptions';

const SnapshotButton = ({ settings }: { settings: any }): JSX.Element => {
  const [showSnapshotModal, setshowSnapshotModal] = useState(false);
  const takeSnapshot = (options: ISnapShotOptions) => {
    if (settings !== null && settings !== undefined) {
      createSnapShot(
        settings.camera,
        settings.renderer,
        settings.scene,
        options
      );
    }
  };

  return (
    <div>
      <SidebarCameraIcon
        className="left-bar-icon"
        onClick={() => setshowSnapshotModal(true)}
      />
      {showSnapshotModal ? (
        <SnapshotModal
          closeModal={() => setshowSnapshotModal(false)}
          takeSnapshot={takeSnapshot}
        />
      ) : null}
    </div>
  );
};

export default SnapshotButton;
